// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file notifications/v1/notifications_service.proto (package notifications.v1, syntax proto3)
/* eslint-disable */

import { NotificationsService } from "./notifications_service_pb";

/**
 * @generated from rpc notifications.v1.NotificationsService.ListSlackChannels
 */
export const listSlackChannels = NotificationsService.method.listSlackChannels;

/**
 * @generated from rpc notifications.v1.NotificationsService.GetSlackUserDmLink
 */
export const getSlackUserDmLink = NotificationsService.method.getSlackUserDmLink;

/**
 * @generated from rpc notifications.v1.NotificationsService.SendNotification
 */
export const sendNotification = NotificationsService.method.sendNotification;

/**
 * @generated from rpc notifications.v1.NotificationsService.SendCommentNotification
 */
export const sendCommentNotification = NotificationsService.method.sendCommentNotification;

/**
 * New subscription management APIs
 *
 * @generated from rpc notifications.v1.NotificationsService.IsUserSubscribedToTenant
 */
export const isUserSubscribedToTenant = NotificationsService.method.isUserSubscribedToTenant;

/**
 * @generated from rpc notifications.v1.NotificationsService.GetUserAssignments
 */
export const getUserAssignments = NotificationsService.method.getUserAssignments;

/**
 * @generated from rpc notifications.v1.NotificationsService.UpdateUserTenantSubscription
 */
export const updateUserTenantSubscription = NotificationsService.method.updateUserTenantSubscription;

/**
 * @generated from rpc notifications.v1.NotificationsService.GetPortalReminderSetting
 */
export const getPortalReminderSetting = NotificationsService.method.getPortalReminderSetting;

/**
 * @generated from rpc notifications.v1.NotificationsService.SetPortalReminderSetting
 */
export const setPortalReminderSetting = NotificationsService.method.setPortalReminderSetting;
